import { concat, defer, Observable, of } from 'rxjs';
import { ofType } from 'redux-observable';
import { catchError, mergeMap, switchMap, withLatestFrom } from 'rxjs/operators';
import { EpicDeps } from '@wearejh/m2-pwa-engine/lib/types';
import { ApolloClient } from 'apollo-client';

import { Actions, CartAddSimpleItem, CartMsg, TypeMap } from '../cart.actions';
import { cartVariantAndId } from '../utils/stateObservables';
import addSimpleQuery from '../queries/addSimpleProductsToCart.graphql';
import {
    addSimpleProductsToCart,
    addSimpleProductsToCartVariables,
} from '../queries/__generated__/addSimpleProductsToCart';
import { refreshCartAndRetry } from '../utils/refreshCartAndRetry';

export function cartAddSimple(actions$: Observable<any>, state: Observable<any>, deps: EpicDeps) {
    return actions$.pipe(
        ofType<Actions, TypeMap['Cart.Add.Simple']>('Cart.Add.Simple'),
        withLatestFrom(cartVariantAndId(state)),
        switchMap(([action, [, cartId]]) => {
            if (!cartId) {
                console.error('Could not add since cartId was missing');
                return refreshCartAndRetry(
                    actions$,
                    action,
                    CartMsg('Cart.AddError', 'could not create cart prior to adding'),
                );
            }
            return addSimpleMutation(deps, String(cartId), action.payload.items).pipe(
                mergeMap(() => {
                    return concat(of(CartMsg('Cart.AddSuccess'), CartMsg('Cart.Refresh', { force: true })));
                }),
                catchError((e) => {
                    console.error(e);
                    return of(CartMsg('Cart.AddError', e.message));
                }),
            );
        }),
    );
}

export function addSimpleMutation(deps: EpicDeps, cartId: string, items: CartAddSimpleItem[]) {
    return defer(() =>
        (deps.client as ApolloClient<any>).mutate<addSimpleProductsToCart, addSimpleProductsToCartVariables>({
            mutation: addSimpleQuery,
            operationName: 'addSimpleProductsToCart',
            variables: {
                input: {
                    cart_id: String(cartId),
                    cart_items: items,
                },
            },
            fetchPolicy: 'no-cache',
        } as any),
    );
}
